import { GateProvider } from "./providers/GateProvider"
import { ModalProvider } from "./providers/ModalProvider"
import { RouteProvider } from "./providers/RouteProvider"
import { AppPanels } from "./providers/RouteProvider/lib/routeConfig"
import "./styles/index.scss"
import bridge from "@vkontakte/vk-bridge"
import { ScreenSpinner } from "@vkontakte/vkui"
import "@vkontakte/vkui/dist/vkui.css"
import { useUnit } from "effector-react"
import { useEffect } from "react"
import { $activePanel, setActivePanel } from "src/entity/ActivePanel"
import { $message, clearMessage } from "src/entity/Messages"
import { $isPostCardPreparing } from "src/entity/PostCard"
import { $pollItems } from "src/entity/Pretendents"
import { $accordionTap } from "src/entity/Pretendents/model/Pretendents"
import { $isStandAlone } from "src/entity/User"
import { $isPosting } from "src/features/postVotes"

export const App = () => {
  const [activePanel, message, onClearMessage, isPosting, isStandAlone, onSetActivePanel, isPostCardPreparing, pollItems] = useUnit([
    $activePanel,
    $message,
    clearMessage,
    $isPosting,
    $isStandAlone,
    setActivePanel,
    $isPostCardPreparing,
    $pollItems,
  ])
  const { accordTap } = useUnit({ accordTap: $accordionTap })

  const sendHeight = () => {
    const element = document?.querySelector(".vkuiInternalGroup, .postcard-content-wrapper")

    if (element) {
      window.parent.postMessage({ type: "iframeResize", height: element.clientHeight }, "*")
    }
  }

  useEffect(() => {
    setInterval(() => {
      sendHeight()
    }, 1000)
  }, [])

  useEffect(() => {
    if (bridge.isIframe() && !bridge.isWebView()) {
      document.body.style.overflow = "hidden"
    }
    if (isStandAlone) {
      // onSetActivePanel(AppPanels.POST_CARD)

      if (activePanel === "second_stage_voiting_panel") {
        sendHeight()

        if (pollItems.length) {
          sendHeight()
        }
      }
    }
    bridge
      .send("VKWebAppGetLaunchParams")
      .then((data) => {
        if (data?.vk_platform) {
          document.body.style.overflow = "auto"
          const docVkRoot = document.querySelector(".vkuiAppRoot")
          if (docVkRoot) {
            docVkRoot.classList.remove("app--standalone")
          }
        }
      })
      .catch((e) => console.log("some problem"))
  }, [isStandAlone, onSetActivePanel, pollItems, accordTap, activePanel])

  return (
    <>
      <GateProvider />
      <RouteProvider activePanel={activePanel} />
      <ModalProvider messageType={message} onClose={onClearMessage} />
      {(isPosting || isPostCardPreparing) && <ScreenSpinner />}
    </>
  )
}
